import { space } from './core'
import { textStyles } from './typography'

const baseDropdownStyles = {
  width: '100%',
  color: 'neutrals.4',
  borderRadius: '4px',
  borderStyle: 'solid',
  borderColor: 'neutrals.3',
  borderWidth: '1px',
  appearance: 'none',
  backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuNTMwMyAwLjQ2OTY3QzEzLjgyMzIgMC43NjI1NjMgMTMuODIzMiAxLjIzNzQ0IDEzLjUzMDMgMS41MzAzM0w3IDguMDYwNjZMMC40Njk2NyAxLjUzMDMzQzAuMTc2Nzc3IDEuMjM3NDQgMC4xNzY3NzcgMC43NjI1NjUgMC40Njk2NyAwLjQ2OTY3MkMwLjc2MjU2MyAwLjE3Njc3OSAxLjIzNzQ0IDAuMTc2Nzc5IDEuNTMwMzMgMC40Njk2NzJMNyA1LjkzOTM0TDEyLjQ2OTcgMC40Njk2N0MxMi43NjI2IDAuMTc2Nzc3IDEzLjIzNzQgMC4xNzY3NzcgMTMuNTMwMyAwLjQ2OTY3WiIgZmlsbD0iIzI1MjgyOSIvPgo8L3N2Zz4K")',
  backgroundPosition: 'calc(100% - 22px) center',
  backgroundRepeat: 'no-repeat',
  '&:hover': {
    borderColor: 'secondary.1'
  }
}

const baseDropdownFocus = {
  outline: 0,
  borderColor: 'secondary.1',
  borderWidth: '2px',
  backgroundPosition: 'calc(100% - 21px) center'
}

const baseDropdownError = {
  borderColor: 'error.2',
  borderWidth: '2px',
  backgroundPosition: 'calc(100% - 21px) center'
}

const dropdowns = {
  large: {
    ...baseDropdownStyles,
    ...textStyles.body.regular.regular,
    py: 3,
    pl: 4,
    pr: 7,
    '&:focus': {
      ...baseDropdownFocus,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[4]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    },
    '&.error': {
      ...baseDropdownError,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[4]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    }
  },
  medium: {
    ...baseDropdownStyles,
    ...textStyles.body.smallPrint.medium,
    py: 3,
    pl: 3,
    pr: 7,
    '&:focus': {
      ...baseDropdownFocus,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[3]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    },
    '&.error': {
      ...baseDropdownError,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[3]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    }
  },
  small: {
    ...baseDropdownStyles,
    ...textStyles.body.smallPrint.medium,
    py: 2,
    pl: 3,
    pr: 7,
    '&:focus': {
      ...baseDropdownFocus,
      py: `calc(${space[2]}px - 1px)`,
      pl: `calc(${space[3]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    },
    '&.error': {
      ...baseDropdownError,
      py: `calc(${space[2]}px - 1px)`,
      pl: `calc(${space[3]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    }
  },
  experimental: {
    ...baseDropdownStyles,
    ...textStyles.body.regular.regular,
    mb: `calc(${space[7]}px - 8px)`,
    mt: `calc(${space[3]}px + 2px)`,
    py: 3,
    pl: 4,
    pr: 7,
    '&:focus': {
      ...baseDropdownFocus,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[4]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    },
    '&.error': {
      ...baseDropdownError,
      py: `calc(${space[3]}px - 1px)`,
      pl: `calc(${space[4]}px - 1px)`,
      pr: `calc(${space[7]}px - 1px)`
    }
  }
}

export default dropdowns
